export default __webpack_public_path__ + "fonts/b81d04a0cce581d86cded00756d8e498.svg";